import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import DropdownIcon from "./Dropdown.icon";
import { StyledContent, StyledDropdownMenu, StyledItem, StyledTrigger, } from "./Dropdown.styled";
export var DropdownMenu = function (_a) {
    var children = _a.children, onOpenChange = _a.onOpenChange, _b = _a.closeOnSelect, closeOnSelect = _b === void 0 ? false : _b;
    var _c = React.useState(false), isOpen = _c[0], setIsOpen = _c[1];
    var dropdownRef = React.useRef(null);
    var handleOpenChange = function (newState) {
        setIsOpen(newState);
        onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(newState);
    };
    React.useEffect(function () {
        var handleClickOutside = function (event) {
            if (dropdownRef.current &&
                !dropdownRef.current.contains(event.target)) {
                handleOpenChange(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function () { return document.removeEventListener("mousedown", handleClickOutside); };
    }, []);
    return (_jsx(StyledDropdownMenu, { ref: dropdownRef, children: React.Children.map(children, function (child) {
            if (React.isValidElement(child)) {
                return React.cloneElement(child, {
                    isOpen: isOpen,
                    setIsOpen: handleOpenChange,
                    closeOnSelect: closeOnSelect,
                });
            }
            return child;
        }) }));
};
export var DropdownMenuTrigger = function (_a) {
    var children = _a.children, setIsOpen = _a.setIsOpen, isOpen = _a.isOpen;
    return (_jsxs(StyledTrigger, { onClick: function () { return setIsOpen === null || setIsOpen === void 0 ? void 0 : setIsOpen(!isOpen); }, children: [_jsx("span", { children: children }), _jsx(DropdownIcon, {})] }));
};
export var DropdownMenuContent = function (_a) {
    var children = _a.children, _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, closeOnSelect = _a.closeOnSelect, setIsOpen = _a.setIsOpen;
    return (_jsx(StyledContent, { isOpen: isOpen, children: React.Children.map(children, function (child) {
            if (React.isValidElement(child)) {
                return React.cloneElement(child, {
                    closeOnSelect: closeOnSelect,
                    setIsOpen: setIsOpen,
                });
            }
            return child;
        }) }));
};
export var DropdownMenuItem = function (_a) {
    var children = _a.children, onClick = _a.onClick, selected = _a.selected, closeOnSelect = _a.closeOnSelect, setIsOpen = _a.setIsOpen;
    var handleClick = function () {
        onClick === null || onClick === void 0 ? void 0 : onClick();
        if (closeOnSelect) {
            setIsOpen === null || setIsOpen === void 0 ? void 0 : setIsOpen(false);
        }
    };
    return (_jsx(StyledItem, { onClick: handleClick, selected: selected, children: children }));
};
//# sourceMappingURL=Dropdown.js.map